"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstChild = getFirstChild;
exports.hasValueInEventTarget = hasValueInEventTarget;
exports.isFunction = isFunction;
exports.isHtmlElement = void 0;
exports.isInputClickEvent = isInputClickEvent;
exports.isInputEl = isInputEl;

var _typeGuards = require("@insided/shared/utils/typeGuards");

/**
 * @deprecated
 * ```
 * import { isHtmlElement } from '@insided/shared/utils/typeGuards'
 * ```
 */
var isHtmlElementDeprecated = _typeGuards.isHtmlElement;
exports.isHtmlElement = isHtmlElementDeprecated;

function isInputEl(el) {
  return !!el && 'value' in el;
}

function hasValueInEventTarget(e) {
  return !!e.target && 'value' in e.target;
}

function isInputClickEvent(e) {
  return !!e.target && 'value' in e.target;
}

function isFunction(child) {
  return typeof child === 'function';
}
/**
 * @deprecated
 * In case of render props use a separate property for that
 */


function getFirstChild(children) {
  return Array.isArray(children) ? children[0] : children;
}